import React from 'react';
import { Col } from 'antd';
import moment from 'moment';
import {
  DataValue,
  DataValueMobile,
  DataHeadingMobile,
  UnderlineLinkGrants,
  DataDescription,
  DashboardDivider,
  DataDescriptionBold,
  UnderlinePurpose,
  DataValueWrapper,
  PointerTriangle,
  Content,
  UnderlineLinkTxn
} from './styles';
import recurringIcon from '../../../../assets/icons/recurring.svg';
import ToolTipContainer from './components/Popup/Popup';
import grantAgreement from '../../../../assets/icons/grant-agreement.svg';
import PurposeSummary from '../../Components/PurposeSummary/PurposeSummary';

import { Link } from 'react-router-dom';
import { checkForFreezeFunctionality,isAllShareAllPool } from '../../../../utils/commonUtil';
import { DataHeading } from '../../../../CommonComponents/commonStyles';

const FLOW_CHECKER = 'RAG';
export function getMilliseconds(date) {
  return parseInt(moment(date).format('x'));
}

export function disabledValidator(accData) {
  let isAllShareAllPoolStatus = isAllShareAllPool();
  return checkForFreezeFunctionality().indexOf(FLOW_CHECKER) !== -1
    ? true
    : false || accData.availableBalance === 0
    ? true
    : false || isAllShareAllPoolStatus
    ? true
    : false || accData.roleAccess === 'Read Only'
    ? true
    : false ;
}

export function disabledText(accData) {
  let isAllShareAllPoolStatus = isAllShareAllPool();
  return checkForFreezeFunctionality().indexOf(FLOW_CHECKER) !== -1
    ? 'Transactions for this account are frozen. Contact us at 888-383-4483 or donorservice@vanguardcharitable.org'
    : '' || accData.availableBalance === 0
    ? 'This account has $0.00 available balance. Granting Transaction cannot continue.'
    : '' || isAllShareAllPoolStatus
    ? 'A grant has been recommended to close the account. Additional grant transactions cannot be submitted.'
    : '' || accData.roleAccess === 'Read Only'
    ? 'You are unable to recommend grants on this account. If you believe this is an error, please contact us at 888-383-4483.'
    : '' ;
}

export function renderPurposeFixGrid({ data, each, label, mtop }) {
  return (
    <Col
      lg={8}
      md={24}
      className={mtop === true ? 'mt1 tab-fix' : 'mt0 tab-fix'}
    >
      <DataHeading className='mt-20'>{label}</DataHeading>
      {data[each].description === '' || data[each].description === null ? (
        <DataValue dashboard> &mdash; </DataValue>
      ) : (
        <DataValue isUnderline className='mt0' dashboard>
          <DataValueWrapper>
            <UnderlinePurpose showCursor>
              {data[each].description}
            </UnderlinePurpose>
            <Content>
              <PointerTriangle />
              <PurposeSummary {...data.purpose} />
            </Content>
          </DataValueWrapper>
        </DataValue>
      )}
    </Col>
  );
}

export function renderGrantAmountGrid({ data, each, label, mtop }) {
  return (
    <Col lg={8} md={24} xs={12} className={mtop === true ? 'mt1' : 'mt0'}>
      <DataHeading className='mt-20'>{label}</DataHeading>
      {data[each] === 0 ? (
        <DataValue> &mdash; </DataValue>
      ) : data[each] !== null ? (
        <DataValue dashboard className='mt0'>
          {'$' +
            Number(data[each]).toLocaleString(undefined, {
              minimumFractionDigits: 2,
              maximumFractionDigits: 2
            })}
        </DataValue>
      ) : (
        <DataValue> &mdash; </DataValue>
      )}
    </Col>
  );
}

export function renderPurposesFixGrid({ data, each, label, mtop }) {
  return (
    <Col lg={8} md={24} xs={12} className={mtop === true ? 'mt1' : 'mt0'}>
      <DataHeading className='mt-20'>{label}</DataHeading>
      {data[each].description === '' || data[each].description === null ? (
        <DataValue dashboard> &mdash; </DataValue>
      ) : (
        <DataValue
          className='mt0'
          showCursor={data[each].additionalComments}
          dashboard
        >
          <ToolTipContainer
            adjustable={true}
            className='contribution'
            placement='bottom'
            title={() => <PurposeSummary {...data.purpose} />}
          >
            <UnderlinePurpose>{data[each].description}</UnderlinePurpose>
          </ToolTipContainer>
        </DataValue>
      )}
    </Col>
  );
}

export function renderUserNameFixGrid({ data, each, label, mtop }) {
  let userName = null;
  // DP User
  if (data['csrFlow'] === false && data['csrDPFlow'] === false) {
    if (data['enteredDate'] > getMilliseconds('05/01/2009')) {
      userName = `${data['dpUserPrefix'] ? data['dpUserPrefix'] : ''}${
        data['dpUserFirstName'] ? ' ' + data['dpUserFirstName'] : ''
      }${data['dpUserMiddleName'] ? ' ' + data['dpUserMiddleName'] : ''}${
        data['dpUserLastName'] ? ' ' + data['dpUserLastName'] : ''
      }${data['dpUserSuffix'] ? ', ' + data['dpUserSuffix'] : ''}`;
    }
  } // Gemini user
  else if (data['csrFlow'] === true && data['csrDPFlow'] === false) {
    if (data['enteredDate'] > getMilliseconds('05/01/2009')) {
      userName = `${data['dpUserPrefix'] ? data['dpUserPrefix'] : ''}${
        data['dpUserFirstName'] ? ' ' + data['dpUserFirstName'] : ''
      }${data['dpUserMiddleName'] ? ' ' + data['dpUserMiddleName'] : ''}${
        data['dpUserLastName'] ? ' ' + data['dpUserLastName'] : ''
      }${data['dpUserSuffix'] ? ', ' + data['dpUserSuffix'] : ''}`;
    }
  }
  return (data['csrFlow'] !== false && data['csrDPFlow'] !== true) ||
    userName !== null ? (
    <Col
      lg={8}
      md={24}
      className={mtop === true ? 'mt1 tab-fix' : 'mt0 tab-fix'}
    >
      <DataHeading className='mt-20'>{label}</DataHeading>
      <DataValue dashboard className='mt0'>
        {userName}
      </DataValue>
    </Col>
  ) : null;
}

export function renderRecurringGrid({ data, each, label, mtop }) {
  return (
    <Col lg={6} md={24} className={mtop === true ? 'mt1' : 'mt0'}>
      <DataHeading className='mt-20'>{label}</DataHeading>
      {data['grantAgreement'] ? (
        <ToolTipContainer
          className='contribution'
          placement='bottomLeft'
          title={'Spawn of a Grant Agreement'}
        >
          <img src={grantAgreement} className='cursor-auto ml2' alt='grants-agreement'/>
        </ToolTipContainer>
      ) : data['isRecurring'] ? (
        <ToolTipContainer
          className='contribution'
          placement='bottomLeft'
          title={'Spawn of a recurring Schedule'}
        >
          <img src={recurringIcon} className='cursor-auto ml2' alt='recurring-schedule'/>
        </ToolTipContainer>
      ) : (
        <DataValue> &mdash; </DataValue>
      )}
    </Col>
  );
}

export function renderGrantsTitleGrid({ data, each, label, index, linkUrl }) {
  return (
    <>
      <Col lg={24} md={24} className={index !== 0 ? 'mt-xs-invest20' : 'mt0'}>
        <UnderlineLinkGrants>
          <Link to={'/'}>
            {label}: {data[each]}
            {data.isRecurring === 'true' ? (
              <img src={recurringIcon} className='cursor-auto ml2' alt='recurring' />
            ) : (
              <div />
            )}
          </Link>
        </UnderlineLinkGrants>
      </Col>
    </>
  );
}

export function renderGrantsGrantsTitleGrid({
  data,
  each,
  label,
  index,
  linkUrl
}) {
  return (
    <>
      <Col lg={24} md={24} className={index !== 0 ? 'mt-xs-invest20' : 'mt0'}>
        <UnderlineLinkGrants>
          <Link to={'/'}>
            {data[each]}
            {data.isRecurring === 'true' ? (
              <img src={recurringIcon} className='cursor-auto ml2' alt='recurring' />
            ) : (
              <div />
            )}
          </Link>
        </UnderlineLinkGrants>
      </Col>
    </>
  );
}

export function renderGrantsIdGrid({ data, each, label, index, linkUrl }) {
  return (
    <>
      <Col lg={24} md={24} className={index !== 0 ? 'mt-xs-invest20' : 'mt0'}>
        <DataDescriptionBold>
          {label}: {data[each]}
          {data.isRecurring === 'true' ? (
            <img src={recurringIcon} className='cursor-auto ml2' alt='' />
          ) : (
            <div />
          )}
        </DataDescriptionBold>
      </Col>
    </>
  );
}

export function renderDescriptionGrid({ data, each, label, index }) {
  return (
    <Col lg={24} md={24} className={index !== 0 ? 'mt-xs-invest20' : 'mt0'}>
      <DataDescription>
        Vanguard New Jersey Long-Term Tax-Exempt Fund Admiral Shares
      </DataDescription>
    </Col>
  );
}

export function renderGrantsDateGrid({ data, each, label, mtop }) {
  return (
    <>
      <Col lg={8} md={12} xs={0} className={mtop === true ? 'mt1' : 'mt0'}>
        <DataHeading className='mt-20'>{label}</DataHeading>
        {data[each] !== null && data[each] !== undefined ? (
          <DataValue dashboard className='mt0'>
            {moment(data[each]).format('L')}
          </DataValue>
        ) : (
          <DataValue dashboard> &mdash; </DataValue>
        )}
      </Col>
      <Col lg={0} md={0} xs={12} className={mtop === true ? 'mt1' : 'mt0'}>
        <DataHeading className='mt-20'>{label}</DataHeading>
        {data[each] !== null && data[each] !== undefined ? (
          <DataValue dashboard className='mt0'>
            {moment(data[each]).format('L')}
          </DataValue>
        ) : (
          <DataValue dashboard> &mdash; </DataValue>
        )}
        <DashboardDivider />
      </Col>
    </>
  );
}

export function renderAmountGrid({ data, each, label, mtop }) {
  return (
    <Col lg={8} md={12} className={mtop === true ? 'mt1' : 'mt0'}>
      <DataHeading className='mt-20'>{label}</DataHeading>
      {data[each] !== null ? (
        <DataValue className='mt0'>
          {'$' +
            Number(data[each]).toLocaleString(undefined, {
              minimumFractionDigits: 2,
              maximumFractionDigits: 2
            })}
        </DataValue>
      ) : (
        <DataValue> &mdash; </DataValue>
      )}
    </Col>
  );
}

export function renderGrantsFixGrid({ data, each, label, mtop }) {
  return (
    <>
      <Col lg={8} md={12} xs={0} className={mtop === true ? 'mt1' : 'mt0'}>
        <DataHeading className='mt-20'>{label}</DataHeading>
        {data[each] === '' || data[each] === null ? (
          <DataValue> &mdash; </DataValue>
        ) : (
          <DataValue className='mt0' dashboard>
            {each === 'status.extDescription'
              ? data.status.extDescription
              : data[each] === 'SHARE'
              ? 'Units'
              : typeof data[each] == 'string'
              ? data[each].charAt(0).toUpperCase() +
                data[each].slice(1).toLowerCase()
              : data[each]}
          </DataValue>
        )}
      </Col>
      <Col lg={0} md={0} xs={label === 'User Name' ? 24 : 12}>
        {label === 'User Name' ? (
          <DataHeadingMobile className='mt-20'>{label}</DataHeadingMobile>
        ) : (
          <DataHeading className='mt-20'>{label}</DataHeading>
        )}
        {data[each] === '' || data[each] === null ? (
          label === 'User Name' ? (
            <DataValueMobile> &mdash; </DataValueMobile>
          ) : (
            <DataValue> &mdash; </DataValue>
          )
        ) : label === 'User Name' ? (
          <DataValueMobile>
            {each === 'status.extDescription'
              ? data.status.extDescription
              : data[each] === 'SHARE'
              ? 'Units'
              : typeof data[each] == 'string'
              ? data[each].charAt(0).toUpperCase() +
                data[each].slice(1).toLowerCase()
              : data[each]}
          </DataValueMobile>
        ) : (
          <DataValue className='mt0'>
            {each === 'status.extDescription'
              ? data.status.extDescription
              : data[each] === 'SHARE'
              ? 'Units'
              : typeof data[each] == 'string'
              ? data[each].charAt(0).toUpperCase() +
                data[each].slice(1).toLowerCase()
              : data[each]}
          </DataValue>
        )}
        <DashboardDivider />
      </Col>
    </>
  );
}

export function renderGrantTitleGrid({
  data,
  each,
  label,
  index,
  linkUrl,
  comingSoon,
  handleTitleClick
}) {
  return (
    <Col lg={24} md={24} className={index !== 0 ? 'mt-xs-invest20' : 'mt0'}>
      {comingSoon ? (
        <span className='tool-tip'>
          <UnderlineLinkTxn  dashboard={true} onClick={handleTitleClick}>
            {label}: {data[each]}
            {data.isRecurring === 'true' ? (
              <img src={recurringIcon} className='cursor-auto ml2' alt='recurring grant' />
            ) : (
              <div />
            )}
          </UnderlineLinkTxn>
          <span>
            <span className='tooltiptext-i'>Coming Soon...</span>
          </span>
        </span>
      ) : (
        <UnderlineLinkTxn onClick={handleTitleClick}>
          {label}: {data[each]}
          {data['grantAgreement'] === true ? (
            <ToolTipContainer
              className='contribution'
              placement={
                window.screen.availWidth >= 320 &&
                425 >= window.screen.availWidth
                  ? 'topRight'
                  : 'bottomLeft'
              }
              title={'Spawn of a Grant Agreement'}
            >
              <img src={grantAgreement} className='cursor-auto ml2' alt='grant agreement'/>
            </ToolTipContainer>
          ) : data['isRecurring'] === 'true' ? (
            <ToolTipContainer
              className='contribution'
              placement='bottomLeft'
              title={'Spawn of a recurring Schedule'}
            >
              <img src={recurringIcon} className='cursor-auto ml2' alt='recurring grant' />
            </ToolTipContainer>
          ) : null}
        </UnderlineLinkTxn>
      )}
    </Col>
  );
}

export function renderDescriptionsGrid({ data, each, label, index }) {
  return (
    <Col lg={24} md={24} className={index !== 0 ? 'mt-xs-invest20' : 'mt0'}>
      {data[each] !== null && data[each].length !== 0 ? (
        <DataDescription>{data[each]}</DataDescription>
      ) : (
        <DataDescription> &mdash; </DataDescription>
      )}
    </Col>
  );
}

export const checkGrid = (data, each, label) => {
  return (
    <>
      <DataHeading className='mt-20'>{label}</DataHeading>
      {data[each] !== null && data[each] !== undefined && data[each] !== 0 ? (
        <DataValue dashboard className='mt0'>
          {data[each]}
        </DataValue>
      ) : (
        <DataValue dashboard> &mdash; </DataValue>
      )}
    </>
  );
};

export function renderGrantsCheckGrid({ data, each, label, mtop }) {
  return (
    <>
      <Col lg={8} md={12} xs={0} className={mtop === true ? 'mt1' : 'mt0'}>
        {checkGrid(data, each, label)}
      </Col>
      <Col lg={0} md={0} xs={12} className={mtop === true ? 'mt1' : 'mt0'}>
        {checkGrid(data, each, label)}
        <DashboardDivider />
      </Col>
    </>
  );
}

export const dateGrid = (displayLabel, displayData) => {
  return (
    <>
      <DataHeading className='mt-20'>{displayLabel}</DataHeading>
      {displayLabel !== null && displayLabel !== undefined ? (
        <DataValue dashboard className='mt0'>
          {moment(displayData).format('L')}
        </DataValue>
      ) : (
        <DataValue dashboard> &mdash; </DataValue>
      )}
    </>
  );
};

export function renderGrantsIssuedDateGrid({
  data,
  each,
  label,
  mtop,
  altLabel,
  altEach
}) {
  let displayLabel = label;
  let displayData = data[each];
  if (data[altEach]) {
    displayLabel = altLabel;
    displayData = data[altEach];
  }
  return (
    <>
      <Col lg={8} md={12} xs={0} className={mtop === true ? 'mt1' : 'mt0'}>
        {dateGrid(displayLabel, displayData)}
      </Col>
      <Col lg={0} md={0} xs={12} className={mtop === true ? 'mt1' : 'mt0'}>
        {dateGrid(displayLabel, displayData)}
        <DashboardDivider />
      </Col>
    </>
  );
}

export const nameGrid = (userName, label) => {
  return (
    <>
      <DataHeading className='mt-20'>{label}</DataHeading>
      <DataValue dashboard className='mt0'>
        {userName}
      </DataValue>
    </>
  );
};

export function renderUserFixGrid({ data, each, label, mtop }) {
  let userName = null;
  if (data['csrDPFlow'] === false) {
    if (data['enteredDate'] > getMilliseconds('05/01/2009')) {
      userName = `${data['dpUserPrefix'] ? data['dpUserPrefix'] : ''}${
        data['dpUserFirstName'] ? ' ' + data['dpUserFirstName'] : ''
      }${data['dpUserMiddleName'] ? ' ' + data['dpUserMiddleName'] : ''}${
        data['dpUserLastName'] ? ' ' + data['dpUserLastName'] : ''
      }${data['dpUserSuffix'] ? ', ' + data['dpUserSuffix'] : ''}`;
    }
  }

  return (data['csrFlow'] !== false && data['csrDPFlow'] !== true) ||
    userName !== null ? (
    <>
      <Col lg={8} md={12} xs={0} className={mtop === true ? 'mt1' : 'mt0'}>
        {nameGrid(userName, label)}
      </Col>
      <Col lg={0} md={0} xs={12} className={mtop === true ? 'mt1' : 'mt0'}>
        {nameGrid(userName, label)}
        <DashboardDivider />
      </Col>
    </>
  ) : null;
}
